import { render, staticRenderFns } from "./pureButton.vue?vue&type=template&id=3e149d46&scoped=true"
import script from "./pureButton.vue?vue&type=script&lang=js"
export * from "./pureButton.vue?vue&type=script&lang=js"
import style0 from "./pureButton.vue?vue&type=style&index=0&id=3e149d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e149d46",
  null
  
)

export default component.exports